import React, { ReactNode } from 'react';
import { CircularProgress } from '@material-ui/core';
import LoadingOverlay from 'react-loading-overlay';

interface SpinnerOverlayProps {
  active: boolean;
  children: ReactNode;
}

const SpinnerOverlay: React.FC<SpinnerOverlayProps> = ({ active, children }: SpinnerOverlayProps) => {
  return (
    <LoadingOverlay
      active={active}
      styles={{
        overlay: (base: Record<string, unknown>) => ({
          ...base,
          background: 'rgba(0, 0, 0, 0.3)',
        }),
      }}
      spinner={<CircularProgress />}
    >
      {children}
    </LoadingOverlay>
  );
};

export default SpinnerOverlay;
